import { takeEvery, all, put, select, call } from '@redux-saga/core/effects';
import actionTypes from '../actions/actionTypes';
import { notificationActions } from '../actions/notifications/notifications';
import i18n from '../../i18n/i18n';
import { navigationActions } from '../actions/navigation/navigation';
import { geoActions } from '../actions/geo/geo';

const accessTokenSelector = state => state.oidc.user.access_token;
const countriesSelector = state => state.geo.countries

function* changeLanguage(action) {
  const accessToken = yield select(accessTokenSelector);

  // store language in the database

  const countries = yield select(countriesSelector);
  if(countries.length > 0) {
    yield put(geoActions.fetchCountries())
  }

  yield put(navigationActions.refreshTitle());

  yield put(notificationActions.enqueueSnackbar({
    message: i18n.t('languageChange'),
    options: {
      variant: 'default'
    },
  }));


}

export function* watchSettings() {
  yield all([
    takeEvery(actionTypes.settings.CHANGE_LANGUAGE, changeLanguage),
  ]);
}